import { Component, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import { UserLogModel } from '../../../api/userlog/userlogs';
import { UserLogService } from '../../../api/userlog/userlog.service';
declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
    selector: 'userlog-page',
    templateUrl: './userlog.html'
})
export class UserLogComponent implements OnInit {
    message: string;
    userloghistoryList: UserLogModel[];
    constructor(private router: Router, private userlogService: UserLogService) { }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN')) {
            $(function () {
                var iidate = new Date()
                iidate.setDate(iidate.getDate())
                $('#iidate').datetimepicker({
                    widgetPositioning: {
                        horizontal: 'left'
                    },
                    icons: {
                        time: "fa fa-clock-o",
                        date: "fa fa-calendar",
                        up: "fa fa-arrow-up",
                        down: "fa fa-arrow-down",
                        previous: 'fa fa-arrow-left',
                        next: 'fa fa-arrow-right'
                    },
                    format: 'YYYY-MM-DD'
                });
            })
            this.initLevel();
        } else {
            this.router.navigate(['/']);
        }
    }
    initLevel() {
        this.userlogService.gUserLog().then(data => {
            this.userloghistoryList = data
        });
    }
    deleteLogHistory() {
        var iiiDate = $("#iidate").val();
        if (iiiDate == undefined || iiiDate == "") {
            $.notify({
                message: "Please Select Date."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        var JsonData = {
            deletedate: iiiDate
        }
        this.userlogService.dUserLog(JsonData).then(data => {
            if (data.status) {
                $.notify({
                    message: "Successfully Cleared History Log."
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
                $(function () {
                    $('#deleteModal').modal('toggle');
                });
                this.userloghistoryList.splice(0, 0, data.data);
            }
            else {
                $.notify({
                    message: "Failed To Delete Log."
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/userlog/userlog.page.ts